import { DEFAULT_OFFSET } from '../../../constants/pagination';
import { GET_LIST_FILE_TAGS, GET_LIST_FILE_TAGS_ERROR, GET_LIST_FILE_TAGS_SUCCESS } from './actionTypes';

const initialState = {
  data: [],
  error: "",
  loading: false,
  pagination: { totalCount: 0, nextOffset: DEFAULT_OFFSET },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_FILE_TAGS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_LIST_FILE_TAGS_SUCCESS:
      state = {
        ...state,
        data: action.payload.data,
        pagination: action.payload.pagination,
        loading: false,
      };
      break;
    case GET_LIST_FILE_TAGS_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }

  return state;
};